import { useState } from 'react'
import { useInfiniteQuery } from 'react-query'
import { useRouter } from 'next/router'
import { isEmpty } from 'lodash-es'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'
import { MALL_DEFAULT_PAGE_SIZE } from '@/constants/mall'

// Types

const defaultEventList = { pageSize: MALL_DEFAULT_PAGE_SIZE, eventId: null }

export const usePopularProductList = ({ defaultPayload = defaultEventList, fetchDataApi, popularProductListDataSSR }: any) => {
  const [popularProductListPayload, setPopularProductListPayload] = useState(defaultPayload)
  const router = useRouter()
  const eventId = router.query.event_id

  const popularListData = useInfiniteQuery(
    [QUERY_KEY.FETCH_POPULAR_PRODUCTS_FROM_MALL, { eventId }],
    ({ pageParam }) =>
      fetchDataApi({
        params: {
          event: 'shop_event_product',
          pageSize: MALL_DEFAULT_PAGE_SIZE,
          pageNo: pageParam,
        },
      }),
    {
      enabled: !isEmpty(eventId) && router.isReady,
      placeholderData: {
        pageParams: [undefined],
        pages: [popularProductListDataSSR],
      },
      staleTime: Infinity,
      getNextPageParam: (lastPage, pages) => {
        if (!router.isReady) return undefined
        const currentPage = pages?.length || 1
        const totalPage = lastPage?.totalPage?.totalPages || 0
        let result: number | undefined = 0
        const allPageData = JSON.stringify({ data: pages })
        const emptyPageDataIdentifier = '"productsInfo":null'

        if (allPageData.includes(emptyPageDataIdentifier)) {
          result = undefined
          return
        }

        if (lastPage?.totalPage.totalPages === 0) {
          result = undefined
        } else {
          const isLastPage = currentPage === totalPage
          result = isLastPage ? undefined : currentPage + 1
        }

        return result
      },
    },
  )

  return { popularListData, popularProductListPayload, setPopularProductListPayload }
}
